<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model" scrollable
                   :title="computedTitle"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" modal-class="mobile-full-screen"
                   :ok-title="$t('Submit')" :content-in-form="false">
      <div class="row">
        <div class="col-md-12" v-if="model.customer">
          <customer-email-address-info :customer="model.customer"></customer-email-address-info>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12 d-flex align-items-center">
          <input-widget :model="model" attribute="is_collected_by_third_party" type="checkbox"/>
        </div>
        <div class="col-md-12" v-if="model.is_collected_by_third_party">
          <input-widget :model="model" attribute="collector"/>
        </div>
        <div class="col-md-12" v-if="model.is_collected_by_third_party">
          <input-widget :model="model" attribute="collector_note"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal.vue";
  import {createNamespacedHelpers} from "vuex";
  import CollectionsModel from "@/modules/collections/Collections.model";
  import InputWidget from "@/core/components/input-widget/InputWidget.vue";
  import CustomerEmailAddressInfo from "@/core/components/customer-info/CustomerEmailAddressInfo.vue";
  import CustomerService from "@/modules/customer/CustomerService";

  const {mapState, mapActions} = createNamespacedHelpers('collections');

  export default {
    name: "CollectionsModal",
    components: {
      InputWidget, ArtisioModal, CustomerEmailAddressInfo
    },
    props: {
    },
    data() {
      return {
        model: new CollectionsModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.collectionsModal,
        customerUuid: state => state.collectionsModal.customer_uuid,
        source: state => state.collectionsModal.source,
        handler: state => state.collectionsModal.handler,
        title: state => state.collectionsModal.title,
      }),
      computedTitle() {
        return this.title ? this.title : this.$i18n.t('Return Items')
      }
    },
    watch: {
      async customerUuid() {
        if (this.customerUuid) {
          let response = await CustomerService.getCustomer(this.customerUuid, 'billing_address')
          if (response.success) {
            this.model.customer = response.body
          }
        }
      },
    },
    methods: {
      ...mapActions([
        "hideCollectionsModal",
      ]),
      onHidden() {
        this.model = new CollectionsModel()
        this.hideCollectionsModal();
      },
      async onSubmit() {
        if (this.source === 'collection_note' || this.source === 'return_note_contract') {
          let response = await this.handler(this.model.getRequestData())
          if (response.success) {
            this.hideCollectionsModal();
          }
        }
      },
    },
  }
</script>

<style scoped lang="scss">
</style>
